import { VWValidator } from "../../../common/VWValidator";
import { VWDiv } from "../../common/VWDiv";
import guiConfig from "../../common/VWGui.json";

const cookieConsentDivData = guiConfig.GUI.VWCookieConsentDiv;
const cookieConsentButtonData = cookieConsentDivData.WebAgentCookieConsentButton;

export class VWCookieConsentDiv implements VWDiv {
    private div: HTMLDivElement;
    private label: HTMLLabelElement;
    private consentButton: HTMLButtonElement;
    private packed: boolean;

    public constructor() {
        this.div = VWCookieConsentDiv.createDiv(cookieConsentDivData.ID, cookieConsentDivData.ClassList);
        this.label = VWCookieConsentDiv.createLabel(cookieConsentDivData.WebAgentCookieConsentLabel.ID, cookieConsentDivData.ID, cookieConsentDivData.WebAgentCookieConsentLabel.ClassList, cookieConsentDivData.WebAgentCookieConsentLabel.Text);
        this.consentButton = VWCookieConsentDiv.createButton(cookieConsentButtonData.ID, cookieConsentButtonData.ClassList, cookieConsentButtonData.Text, cookieConsentButtonData.Title);

        this.consentButton.addEventListener("click", () => {
            document.cookie = "cookie_consent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; secure; samesite=strict";

            location.reload();
        });

        this.packed = false;
    }

    private static createDiv(id: string, classList: string[]): HTMLDivElement {
        const div: HTMLDivElement = document.createElement("div");

        div.id = id;
        div.classList.add(...classList);
        div.hidden = true;

        return div;
    }

    private static createLabel(id: string, forID: string, classList: string[], text: string): HTMLLabelElement {
        const label: HTMLLabelElement = document.createElement("label");

        label.id = id;

        if (forID) {
            label.htmlFor = forID;
        }

        label.classList.add(...classList);
        label.textContent = text;

        return label;
    }

    private static createButton(id: string, classList: string[], text: string, title: string): HTMLButtonElement {
        const button: HTMLButtonElement = document.createElement("button");

        button.id = id;
        button.classList.add(...classList);
        button.textContent = text;
        button.title = title;

        return button;
    }

    public getDiv(): HTMLDivElement {
        VWValidator.validateExistence(this.div, "The cookie consent div is null or undefined.");

        if (!this.packed) {
            this.pack();
        }

        return this.div;
    }

    public pack(): void {
        if (this.packed) {
            console.log("The cookie consent div is already packed.");
        }
        else if (!VWValidator.allArgumentsExist(this.div)) {
            throw new Error("Cannot pack: the cookie consent div is null or undefined.");
        }
        else if (!VWValidator.allArgumentsExist(this.label, this.consentButton)) {
            throw new Error("Cannot pack: one or more of its components are null or undefined.");
        }
        else if (!this.div.hidden) {
            throw new Error("Cannot pack: the cookie consent div is not hidden (it must be before packing it).");
        }
        else {
            this.div.appendChild(this.label);
            this.div.appendChild(this.consentButton);

            this.packed = true;
        }
    }

    public unpack(): void {
        if (!this.packed) {
            console.log("The cookie consent div is already unpacked.");
        }
        else if (!VWValidator.allArgumentsExist(this.div)) {
            throw new Error("Cannot unpack: the cookie consent div is null or undefined.");
        }
        else if (!this.div.hidden) {
            throw new Error("Cannot unpack: the cookie consent div is not hidden (it must be before unpacking it).");
        }
        else {
            VWCookieConsentDiv.removeChildrenFromDiv(this.div);

            this.packed = false;
        }
    }

    public isPacked(): boolean {
        return this.packed;
    }

    public hide(): void {
        if (!VWValidator.allArgumentsExist(this.div)) {
            throw new Error("Cannot hide: the cookie consent div is null or undefined.");
        }
        else if (this.div.hidden) {
            console.log("The cookie consent div is already hidden.");
        }
        else if (!this.packed) {
            throw new Error("Cannot hide: the cookie consent div is not packed.");
        }
        else {
            this.div.hidden = true;
        }
    }

    public show(): void {
        if (!VWValidator.allArgumentsExist(this.div)) {
            throw new Error("Cannot show: the cookie consent div is null or undefined.");
        }
        else if (!this.div.hidden) {
            console.log("The cookie consent div is already shown.");
        }
        else if (!this.packed) {
            throw new Error("Cannot show: the cookie consent div is not packed.");
        }
        else {
            this.div.hidden = false;
        }
    }

    public isHidden(): boolean {
        return this.div.hidden;
    }

    private static removeChildrenFromDiv(div: HTMLDivElement): void {
        while (div.firstChild) {
            div.removeChild(div.firstChild);
        }
    }
}
